import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function skipShahkar(token, params){

    try {
        return await Api.put(REQUEST_URLS.ESTATE.SKIP_SHAHKAR,params,{
            headers:{
                "Authorization": `Bearer ${token}`
            }
        });
    }
    catch (e){

    }

}
export default skipShahkar;